// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICipQuestionnaireAnswersRequestDto
 */
export interface ICipQuestionnaireAnswersRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ICipQuestionnaireAnswersRequestDto
     */
    question1_type: string;
    /**
     * 
     * @type {string}
     * @memberof ICipQuestionnaireAnswersRequestDto
     */
    question1_answer: string;
    /**
     * 
     * @type {string}
     * @memberof ICipQuestionnaireAnswersRequestDto
     */
    question2_type: string;
    /**
     * 
     * @type {string}
     * @memberof ICipQuestionnaireAnswersRequestDto
     */
    question2_answer: string;
    /**
     * 
     * @type {string}
     * @memberof ICipQuestionnaireAnswersRequestDto
     */
    question3_type: string;
    /**
     * 
     * @type {string}
     * @memberof ICipQuestionnaireAnswersRequestDto
     */
    question3_answer: string;
}

/**
 * Check if a given object implements the ICipQuestionnaireAnswersRequestDto interface.
 */
export function instanceOfICipQuestionnaireAnswersRequestDto(value: object): value is ICipQuestionnaireAnswersRequestDto {
    if (!('question1_type' in value) || value['question1_type'] === undefined) return false;
    if (!('question1_answer' in value) || value['question1_answer'] === undefined) return false;
    if (!('question2_type' in value) || value['question2_type'] === undefined) return false;
    if (!('question2_answer' in value) || value['question2_answer'] === undefined) return false;
    if (!('question3_type' in value) || value['question3_type'] === undefined) return false;
    if (!('question3_answer' in value) || value['question3_answer'] === undefined) return false;
    return true;
}

export function ICipQuestionnaireAnswersRequestDtoFromJSON(json: any): ICipQuestionnaireAnswersRequestDto {
    return ICipQuestionnaireAnswersRequestDtoFromJSONTyped(json, false);
}

export function ICipQuestionnaireAnswersRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipQuestionnaireAnswersRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'question1_type': json['question1_type'],
        'question1_answer': json['question1_answer'],
        'question2_type': json['question2_type'],
        'question2_answer': json['question2_answer'],
        'question3_type': json['question3_type'],
        'question3_answer': json['question3_answer'],
    };
}

export function ICipQuestionnaireAnswersRequestDtoToJSON(json: any): ICipQuestionnaireAnswersRequestDto {
    return ICipQuestionnaireAnswersRequestDtoToJSONTyped(json, false);
}

export function ICipQuestionnaireAnswersRequestDtoToJSONTyped(value?: ICipQuestionnaireAnswersRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question1_type': value['question1_type'],
        'question1_answer': value['question1_answer'],
        'question2_type': value['question2_type'],
        'question2_answer': value['question2_answer'],
        'question3_type': value['question3_type'],
        'question3_answer': value['question3_answer'],
    };
}

